class Contact {
    constructor(data = {}) {
      this.id = data.id || data._id || null;
      this._id = data._id || data.id || null;
      this.firstName = data.firstName || '';
      this.lastName = data.lastName || '';
      this.email = data.email || '';
      this.phone = data.phone || '';
      this.mobile = data.mobile || '';
      this.company = data.company || '';
      this.jobTitle = data.jobTitle || '';
      this.department = data.department || '';
      this.accountId = data.accountId || null;
      this.leadSource = data.leadSource || 'Website';
      this.status = data.status || 'Active';
      this.type = data.type || 'Customer';
      this.address = data.address || '';
      this.city = data.city || '';
      this.state = data.state || '';
      this.country = data.country || 'India';
      this.postalCode = data.postalCode || '';
      this.notes = data.notes || '';
      this.assignedTo = data.assignedTo || null;
      this.createdAt = data.createdAt || new Date().toISOString();
    }
  
    getFullName() { return `${this.firstName} ${this.lastName}`.trim(); }
    getStatusColor() {
      const colors = { 'Active': '#10b981', 'Inactive': '#ef4444', 'Pending': '#f59e0b' };
      return colors[this.status] || '#6b7280';
    }
    validate() {
      const errors = [];
      if (!this.firstName?.trim()) errors.push('First name is required');
      if (!this.lastName?.trim()) errors.push('Last name is required');
      if (!this.email?.trim()) errors.push('Email is required');
      else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)) errors.push('Email is invalid');
      return { isValid: errors.length === 0, errors };
    }
    toJSON() { return { ...this }; }
    static fromJSON(json) { return new Contact(json); }
  }
  export default Contact;